import {EVENT_STATUS} from '@/utilities/constants/event'
import {PLATFORMS} from '../services/constants'

export const eventFiltersContent = {
    statuses: [EVENT_STATUS.Closed, EVENT_STATUS.Open, EVENT_STATUS.Scheduled],
    platforms: [PLATFORMS.NonEuropeana, PLATFORMS.Europeana]
}
